import { Schema, Udp } from "../../../../../@types";
import Name from "../../../../../../search/schema/components/Name";
import { enums } from "../../../../../../../shim/jsbridge";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const udp: Schema<Udp> = {
  fields: [
    {
      name: "src",
      displayTitle: "Source",
      sortable: true,
      component: (d: Udp) => (
        <Name
          data={{
            file_name: d.src,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "sport",
      displayTitle: "Source port",
      sortable: true,
      component: (d: Udp) => <>{d.sport}</>
    },
    {
      name: "dst",
      displayTitle: "Destination",
      sortable: true,
      component: (d: Udp) => (
        <Name
          data={{
            file_name: d.dst,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dport",
      displayTitle: "Destination port",
      sortable: true,
      component: (d: Udp) => <>{d.dport}</>
    }
  ]
};
